import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertTypePipe } from './alert-type.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    AlertTypePipe
  ],
  exports: [
    AlertTypePipe
  ]
})
export class AlertTypeModule { }
